import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../config';

const Login = ({ setAuthToken }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/api/login/`, {
        email,
        password,
      });

      setAuthToken(response.data.token);
      localStorage.setItem('authToken', response.data.token);
      setMessage('Login successful.');
      navigate('/');
    } catch (error) {
      if (error.response && error.response.data) {
        const data = error.response.data;
        const msg = data.detail || data.message || JSON.stringify(data);
        setMessage(`Login failed: ${msg}`);
      } else if (error.request) {
        setMessage('Login failed: No response from server.');
      } else {
        setMessage(`Login failed: ${error.message}`);
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 className="auth-title">Sign in</h2>
        <p className="auth-subtitle">Welcome back to Vegbox</p>
        <div className="mb-3">
          <label className="auth-label">Email</label>
          <input
            type="email"
            className="form-control auth-input"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="auth-label">Password</label>
          <input
            type="password"
            className="form-control auth-input"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="auth-links">
          <a href="/forgotpassword">Forgot password?</a>
          <a href="/register">Create account</a>
        </div>
        <button className="auth-btn" onClick={handleLogin}>
          Sign in
        </button>
        {message && <p className="auth-message">{message}</p>}
      </div>
    </div>
  );
};

export default Login;
